<script setup lang="ts">
import type { SizeArea } from './SizeGuide4Card.vue'

const t2 = useT2({
  'How to measure?': 'Kaip matuoti?',
})

const props = defineProps<{
  guide: gen.SellerSizeGuideFragment
  hash: string
}>()

const data = shallowReactive({
  activeUnit: undefined as string | undefined,
})

type UiCard = {
  key: string
  title: string | None
  areas: {
    key: string
    name: string | None
    title: string | None
    value: string | None
    unit: string | None
  }[]
}

const tableAll = computed(() => {
  const { values, areas, sizes, units } = props.guide || {}
  const unit = data.activeUnit || units?.at(0)?.key
  const unitTitle = helpers.arrFindId(units, unit, (i) => i.key)?.unit

  const res: UiCard[] = []

  const howToMeasureArea = helpers.arr(areas, (item): SizeArea => {
    return {
      key: item.key,
      name: item.name,
      title: item.title?.value,
      value: item.description?.value,
      unit: undefined,
    }
  })

  sizes?.forEach((size) => {
    const valuesSize = size ? helpers.arr(values).filter((i) => i.sizeKey === size.key && i.unitKey === unit) : []
    res.push({
      title: size.title?.value,
      key: size.key,
      areas: helpers.arr(areas, (item) => {
        return {
          key: item.key,
          name: item.name,
          unit: unitTitle,
          title: item.title?.value,
          value: helpers.arrFindId(valuesSize, item.key, (i) => i.areaKey)?.value,
        }
      }),
    })
  })

  return {
    unit,
    howToMeasureArea,
    areas,
    items: res,
  }
})
</script>

<template>
  <div :id="hash" class="_pt8">
    <div class="_row _ctrY _spaced _pb2">
      <h2>{{ guide.title.value }}</h2>
      <SizeGuide4Units :units="guide?.units" :model-value="tableAll.unit" @update:model-value="(i) => (data.activeUnit = i)" />
    </div>

    <table ref="table" :class="$style.table">
      <tbody>
        <tr>
          <td>
            <!--  -->
          </td>
          <td v-for="item in tableAll.areas" :key="item.key">
            <em :class="$style.nr">{{ item.name }}</em>
            <span class="_fw-xl _fs09">{{ item.title?.value }}</span>
          </td>
        </tr>

        <tr v-for="table2 in tableAll.items" :id="table2.key" :key="table2.key">
          <td>
            <h3>{{ table2.title }}</h3>
          </td>

          <td v-for="item in table2.areas" :key="item.key">
            <div class="_fs1 _fw-l">
              <template v-if="item.value"
                >{{ item.value }}<div v-if="item.unit" class="_italic _inline _noline _pl04">{{ item.unit }}</div></template
              >
              <template v-else>-</template>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <div :class="$style.bottom">
      <div :class="$style.bottom1">
        <BaseImage :img="props.guide?.image" sizes="420px" fit="fit" :no-color="true" />
      </div>
      <div :class="$style.bottom2">
        <SizeGuide4Card on :instructions="props.guide?.instructionsNote?.value" :title="t2('How to measure?')" :measurments="props.guide?.measurmentsNote?.value" :areas="tableAll.howToMeasureArea" />
      </div>
    </div>
  </div>
</template>

<style module>
.bottom {
  composes: global(_grid);
  grid-template: max-content / repeat(2, minmax(0, 1fr));

  border: 1px solid var(--blue3);
  border-width: 0 1px 1px;
}
.bottom1 {
  composes: global(_ctr);
  composes: global(_bg0);

  max-height: 80vh;
}
.bottom2 {
  border: 1px solid var(--blue3);
  border-width: 0 0 0 1px;
}

.nr {
  composes: global(_mono);
  composes: global(_lh1);
  composes: global(_fs12);
  composes: global(_fw-xxl);
  composes: global(_pr1);
}

.table {
  composes: global(_w100p);
  border-collapse: collapse;
}

.table td {
  border: 1px solid var(--blue3);
  padding: 10px;
  font-size: var(--fs-09);
  line-height: 1.4;
}

.table tr {
  min-height: 40px;
  border: 1px solid var(--blue3);
}
</style>
